import { useDispatch } from "react-redux";
import React, { useLayoutEffect, useState } from "react";
import Button from "components/UI/Button/Button";
import { setNavbarTitle } from "features/navbar/navbarSlice";

import layoutStyles from "components/BaseLayout/BaseLayout.module.scss";
import styles from "pages/AccountSettings/AccountSettings.module.scss";
import ChangePassword from "components/ChangePassword/ChangePassword";
import Configuration from "components/Configuration/Configuration";

const TABS = {
  PASSWORD: 0,
  CONFIG: 1,
};

const AccountSettings = () => {
  const dispatch = useDispatch();
  const [tabs, setTab] = useState(TABS.PASSWORD);

  useLayoutEffect(() => {
    dispatch(setNavbarTitle("My Account Settings"));
  }, [dispatch]);

  const renderContent = () => {
    switch (tabs) {
      case TABS.PASSWORD:
        return <ChangePassword />;
      case TABS.CONFIG:
        return <Configuration />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <div
          className={`${styles.tabs__item} ${tabs === TABS.PASSWORD ? styles.active : ""}`}
          onClick={() => setTab(TABS.PASSWORD)}
        >
          <Button>Change Password</Button>
        </div>
        <div
          className={`${styles.tabs__item} ${tabs === TABS.CONFIG ? styles.active : ""}`}
          onClick={() => setTab(TABS.CONFIG)}
        >
          <Button>Configurations</Button>
        </div>
      </div>

      <div className={styles.content}>{renderContent()}</div>

      <style>
        {`
          .${layoutStyles.content__card} {
            background-color: #f6f7f8 !important;
          }
        `}
      </style>
    </div>
  );
};

export default AccountSettings;
